export const appsettings = {
  rootUrl: 'http://34.244.173.118:6060/',
 // rootUrl: 'http://18.202.246.132/api/',

  // rootUrl: 'http://192.168.5.124:9999/',
  //rootUrl:'http://127.0.0.1:8000/',
  siteTitle: 'Sharp Home Appliances',
  defaultCountry: 'eu'
};